import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightSearchTerm'
})
export class HighlightSearchTermPipe implements PipeTransform {

  transform(value: string, args: string): any {
    if (args && value) {
      value = String(value); // make sure its a string
      const startIndex = value.toLowerCase().indexOf(args.toLowerCase());
      const startHtmlIndex=value.indexOf("<");
      const endHtmlIndex=value.indexOf(">");
      if (startIndex !== -1 && !(startIndex >= startHtmlIndex && startIndex <= endHtmlIndex)) {
          const matchingString = value.substr(startIndex, args.length);
          return value.replace(matchingString, '<span class="highlightSearchTerm">' + matchingString + '</span>');
      }

    }
    return value;
  }
}
